import { Stack, SvgIconProps, Tooltip } from "@mui/material";
import { LogoutIcon } from "src/foundations/icons";
import { GridColDef } from "@mui/x-data-grid";

export interface SenecDataGridLinkColumnProps {
    header?: string;
    tooltipText?: string;
    Icon?: React.FC<SvgIconProps>;
    urlBuilder?: <T>(row: T) => string;
}

export const SenecDataGridLinkColumn = ({
    header,
    tooltipText,
    Icon = LogoutIcon,
    urlBuilder,
}: SenecDataGridLinkColumnProps): GridColDef => {
    return {
        field: "urlLink",
        headerName: header ?? "Link",
        width: 1,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        ...(header === undefined && { renderHeader: () => null }),
        renderCell: (params) => (
            <LinkColumnIconButton
                key={params.row.id}
                tooltipText={tooltipText}
                url={urlBuilder?.(params.row)}
                disabled={!params.api.isRowSelectable(params.id)}
                Icon={Icon}
            />
        ),
    };
};

const LinkColumnIconButton = ({
    tooltipText,
    url,
    disabled,
    Icon,
}: {
    tooltipText?: string;
    url?: string;
    disabled?: boolean;
    Icon: React.FC<SvgIconProps>;
}) => {
    return (
        <Tooltip title={tooltipText} placement="top" sx={{ zIndex: 1 }} disableHoverListener={disabled}>
            <Stack>
                <Icon
                    sx={{ cursor: disabled ? "default" : "pointer" }}
                    color={disabled ? "disabled" : "action"}
                    onClick={
                        disabled
                            ? undefined
                            : url
                              ? (e) => {
                                    e.stopPropagation();
                                    window.open(url, "_blank");
                                }
                              : undefined
                    }
                />
            </Stack>
        </Tooltip>
    );
};
